/** List destinations keep the floating navigation. Detail/task surfaces use
 * their back controls instead, and must not reserve a phantom tab-bar gutter.
 * Preview routes exercise the same policy as their authenticated counterparts.
 */
export function showsMobileNavigation(pathname: string): boolean {
  const path = pathname.replace(/^\/preview(?=\/)/, "");
  return [
    "/marketplace",
    "/marketplace/browse",
    "/offers",
    "/team",
    "/feed",
    "/threads",
  ].includes(path);
}
